
const columns = [
    {
        title: "تاریخ ثبت",
        dataIndex: "createdAt",
        key: "createdAt",
        width: 130,
        sorter: true,
      },
  {
    title: "نام",
    dataIndex: "user",
    key: "user",
    width: 160,
    ellipsis: true
  },
  {
    title: "روز تعطیل",
    dataIndex: "workAt",
    key: "workAt",
    width: 130,
    sorter: true,
  },
  {
    title: "ساعت کار",
    dataIndex: "time",
    key: "time",
    width: 140,
  },
  {
    title: "جزییات",
    dataIndex: "details",
    key: "details",
    width: 140,
  },
];

export default columns;
